import React from 'react'
import { Redirect } from 'react-router-dom'

import LazyImport from 'src/HOC/LazyImport'
import withAuthentication from 'src/HOC/withAuthentication'
import withOutAuthentication from 'src/HOC/withOutAuthentication'
import AuthLayout from 'src/components/App/components/AuthLayout'
import NotFound from 'src/scenes/NotFound'

export const deliveryManagerRoutes = [
  {
    path: '/auth',
    component: withOutAuthentication(AuthLayout),
    routes: [
      {
        path: '/auth/login',
        component: LazyImport(() =>
          import('src/scenes/Auth/scenes/Login' /* webpackChunkName: "Login" */)
        )
      },
      {
        path: '/auth/set-password',
        component: LazyImport(() =>
          import(
            'src/scenes/Auth/scenes/SetPassword' /* webpackChunkName: "Set Password" */
          )
        )
      },
      {
        path: '/auth/forgot-password',
        component: LazyImport(() =>
          import(
            'src/scenes/Auth/scenes/ForgotPassword' /* webpackChunkName: "Forgot Password" */
          )
        )
      },
      {
        path: '/auth/reset-password',
        component: LazyImport(() =>
          import(
            'src/scenes/Auth/scenes/ResetPassword' /* webpackChunkName: "Reset Password" */
          )
        )
      },
      {
        path: '/auth',
        component: () => <Redirect to="/auth/login" />
      }
    ]
  },
  {
    path: '/',
    component: withAuthentication(
      LazyImport(() =>
        import(
          'src/components/App/components/AdminLayout' /* webpackChunkName: "AdminLayout" */
        )
      )
    ),
    routes: [
      {
        exact: true,
        path: '/',
        component: () => <Redirect to="/medical-device-ordering" />
      },
      {
        path: '/medical-device-ordering',
        component: LazyImport(() =>
          import(
            'src/scenes/Companies/scenes/MedicalDeviceOrdering' /* webpackChunkName: "MedicalDeviceOrdering" */
          )
        )
      }
    ]
  },
  {
    path: '/not-found',
    component: NotFound
  },
  {
    path: '*',
    component: () => <Redirect to="/not-found" />
  }
]
